module.exports = __webpack_public_path__ + "static/media/DROC3.a3fb9850.gif";